<template>
	<div class="product-tracking">
		<div class="modal-body">
			<div class="alert alert-warning mb-4">
				Please be aware, that this settings will override all tracking settings on the selected products form.
			</div>
			<div class="row">
				<div class="col-md-6">
					<!-- Form Tracking -->
					<box-tracking
						:title="'Form Page Tracking'"
						:pixel-ids="pixelIds"
						:pixel-events="pixelEvents"
						:selected-pixel-ids="pixel.ids"
						:selected-pixel-events="pixel.events"
						:gtm-ids="gtmIds"
						:selected-gtm-ids="gtm.ids"
						:selected-tiktok-pixel-ids="tiktok.ids"
						v-bind:pixel-configs.sync="pixelConfigs">
					</box-tracking>
				</div>
				<div class="col-md-6">
					<!-- Success Tracking -->
					<box-tracking
						:title="'Success Page Tracking'"
						:pixel-ids="pixelIds"
						:pixel-events="pixelEvents"
						:selected-pixel-ids="pixelSuccess.ids"
						:selected-pixel-events="pixelSuccess.events"
						:gtm-ids="gtmIds"
						:selected-gtm-ids="gtmSuccess.ids"
						:selected-tiktok-pixel-ids="tiktokSuccess.ids"
						v-bind:pixel-configs.sync="pixelSuccessConfigs">
					</box-tracking>
				</div>
			</div>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-light" @click="$emit('cancel')">Cancel</button>
			<button type="button" class="btn btn-primary" :class="{ 'is-loading': isSaving }" @click="save">{{ $t('Save') }}</button>
		</div>
	</div>
</template>

<script>
import BoxTracking from './BoxTracking.vue';
import { duplicateVar } from '../lib/helper';
import { defaultPixelConfig } from '../lib/statics';
import productsApi from '../api/products';

export default {
	name: 'ProductTracking',
	props: {
		productIds: {
			type: Array,
			default: () => [],
		},
		pixelIds: {
			type: Array,
			default: () => [],
		},
		gtmIds: {
			type: Array,
			default: () => [],
		},
		pixelEvents: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		BoxTracking,
	},
	data() {
		return {
			pixel: {
				ids: [],
				events: [],
			},
			pixelSuccess: {
				ids: [],
				events: [],
			},
			gtm: {
				ids: [],
				events: [],
			},
			gtmSuccess: {
				ids: [],
				events: [],
			},
			tiktok: {
				ids: [],
			},
			tiktokSuccess: {
				ids: [],
			},
			pixelConfigs: [],
			pixelSuccessConfigs: [],
			isSaving: false,
		};
	},
	methods: {
		save() {
			this.isSaving = true;
			const productIds = JSON.stringify(this.productIds);
			const trackingJSON = JSON.stringify(this.trackingData);
			const params = {
				product_ids: productIds,
				tracking: trackingJSON,
			};
			const callback = () => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Product Tracking',
					text: 'Updated successfully',
				});
				this.$emit('cancel');
			};
			const errorCallback = () => {
				this.isSaving = false;
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Product Tracking',
					text: 'Something error, please try again',
				});
			};
			productsApi.updateTracking(params, callback, errorCallback);
		},
	},
	computed: {
		trackingData() {
			// const pixelEventsFormatter = pixelEvent => ({ name: pixelEvent, value: '', currency: '' });
			/**
			* @param {Object[]} configs
			*/
			const pixelEventsFormatter = configs => (pixelEvent) => {
				const config = configs.find(({ name }) => name === pixelEvent);
				const newPixelEvent = config || { name: pixelEvent, ...defaultPixelConfig };
				return newPixelEvent;
			};

			const pixel = duplicateVar(this.pixel);
			const pixelEvents = pixel.events.map(pixelEventsFormatter(this.pixelConfigs));
			pixel.events = pixelEvents;

			const pixelSuccess = duplicateVar(this.pixelSuccess);
			const pixelSuccessEvents = pixelSuccess.events.map(pixelEventsFormatter(this.pixelSuccessConfigs));
			pixelSuccess.events = pixelSuccessEvents;

			const trackingData = {
				form: {
					pixel,
					gtm: this.gtm,
					tiktokPixel: this.tiktok,
				},
				success: {
					pixel: pixelSuccess,
					gtm: this.gtmSuccess,
					tiktokPixel: this.tiktokSuccess,
				},
			};
			return trackingData;
		},
	},
};
</script>
